const styles = theme => ({
  main: {
    margin: theme.spacing(1)
  }
})

export default styles
